import { createContext } from 'react';

import { useGuardedContext } from '@/hooks/useGuardedContext';
import { DocumentType } from '@/types/schema';

export type DocumentsTableVariant = 'household-documents' | 'entity-documents';

export interface DocumentsTableContextValue {
  filterValue: Record<'documentType', DocumentType[]>;
  setFilterValue: (value: Record<'documentType', DocumentType[]>) => void;
  variant?: DocumentsTableVariant;
}

export const DocumentsTableContext = createContext<DocumentsTableContextValue>({
  filterValue: { documentType: [] },
  setFilterValue: () => null,
  variant: undefined,
});

export const useDocumentsTableContext = () => {
  return useGuardedContext(DocumentsTableContext, 'DocumentsTableProvider');
};
